/**
 * Returns the current year as a string.
 */
export const getCurrentYear = () => {
  return new Date().getUTCFullYear().toString();
};
